import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { EstateFormType } from '@/modules/estate/models/EstateFormType';
import { EstateFormKey } from '/@/modules/estate/constants/EstateFormKey';
import { EstateNotificationStatus } from '/@/modules/estate/constants/EstateNotificationStatus';
import { EsignTemplate } from '/@/modules/esign/models/EsignTemplate';
import { range } from 'lodash';
import Lang from '@/modules/core/app/services/Lang';

export class EstateForm extends BaseEntityModel {
  id?: number;
  estateId?: number;
  esignTemplateKey?: number;
  type: string;
  wasPreviouslyCompleted?: boolean;
  isRequired: boolean;
  numberOfCopies?: number;
  status?: string;
  esignTemplate?: Relationship<EsignTemplate>;

  constructor(model: Partial<EstateForm> = {}) {
    super(model);

    this.id = model.id;
    this.estateId = model.estateId;
    this.esignTemplateKey = model.esignTemplateKey;
    this.type = model.type as string;
    this.wasPreviouslyCompleted = model.wasPreviouslyCompleted;
    this.isRequired = !!model.isRequired;
    this.numberOfCopies = model.numberOfCopies;
    this.status = model.status;
    this.esignTemplate = EsignTemplate.mapModelOrNull(model.esignTemplate) ?? undefined;
  }

  get displayText(): string | undefined {
    return EstateFormType.getByKey(this.type)?.value;
  }

  get displayType(): string | undefined | null {
    return EstateFormType.getByKey(this.type)?.displayType;
  }

  get columnDisplayText(): string | undefined | null {
    return EstateFormType.getByKey(this.type)?.columnDisplayText ?? this.displayType;
  }

  get isHidden(): boolean {
    return (
      EstateFormType.getByKey(this.type)?.key === EstateFormKey.DIRECTIONS_AND_AUTHORIZATION ||
      EstateFormType.getByKey(this.type)?.key === EstateFormKey.TAX_AUTHORIZATION_FORM
    );
  }

  get isComplete(): boolean {
    return this.status === EstateNotificationStatus.COMPLETE.key;
  }

  get isDone(): boolean {
    return this.status !== EstateNotificationStatus.TODO.key;
  }

  get minCopies(): number {
    return EstateFormType.getByKey(this.type)?.minCopies as number;
  }

  get maxCopies(): number {
    return EstateFormType.getByKey(this.type)?.maxCopies as number;
  }

  get canEditNumberOfCopies(): boolean {
    return !isNaN(this.minCopies) && !isNaN(this.maxCopies);
  }

  get copyEditText(): string | undefined {
    return EstateFormType.getByKey(this.type)?.copyEditText;
  }

  getNumberOfCopyToggleOptions(): { key: number; value: number | string }[] {
    const values: { key: number; value: number | string }[] = range(
      this.minCopies,
      this.maxCopies + 1
    ).map((value: number): { key: number; value: number | string } => {
      return { key: value, value };
    });

    if (this.minCopies === 0) {
      values.shift();
      values.push({ key: 0, value: Lang.t('beneficiary.none') });
    }

    return values;
  }
}
